<template>
  <div class="batch-search">
    <div
      class="detail-item-icon"
      :style="{color: iconColor,width: size,height: size}"
    >
      <icon-svg
        name="status"
        class="detail-item-svg"
        :style="{fontSize: size}"
      />
      <div
        class="detail-item-div"
        :style="{lineHeight: size}"
      >
        {{status}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'waiting',
    },
    // 文字
    status: {
      type: String,
      default: '',
    },
    // 颜色
    color: {
      type: String,
      default: '',
    },
    // 大小
    size: {
      type: String,
      default: '84px',
    },
  },
  computed: {
    iconColor() {
      if (this.color) {
        return this.color;
      }
      const list = {
        waiting: '#FFA040', // 等待 Blue（主题色）
        part: '#FFC02A', // 部分 Yellow
        success: '#42D984', // 成功 Green
        error: '#FF3741', // 失败 Red
        other: '#C9CCD1', // 其他 Grey4
      };
      return list[this.type] || '';
    },
  },
};
</script>
<style scoped lang="scss">
.detail-item-icon {
  position: absolute;
  top: -10px;
  right: 0px;
  z-index: 999;
}
.detail-item-svg {
  position: absolute;
  top: 0px;
  right: 0px;
}
.detail-item-div {
  transform: rotate(25deg);
  text-align: center;
  font-size: 18px;
}
</style>
